'use client'
import SwapDefaultMode from '@/components/Swap/SwapDefaultMode'
import { Suspense } from 'react'
import { SwapSkeleton } from '@/components/common/Audio'
export const runtime = 'edge'

const SwapPage: React.FC = () => {
  return (
    <Suspense fallback={<SwapSkeleton />}>
      <SwapDefaultMode />
    </Suspense>
  )
}

export default SwapPage
